import { action } from 'satcheljs';

export const initializeTrueTimeStore = action('initializeTrueTimeStore');

export const trueTimeStoreInitialized = action('trueTimeStoreInitialized');

export const updateMergedViewAvailabilityAccountCompleted = action(
    'updateMergedViewAvailabilityAccountCompleted',
    (primarySmtpAddress: string, updateSuccessful: boolean) => ({
        primarySmtpAddress,
        updateSuccessful,
    })
);

export const updatingTrueTimeStore = action(
    'updatingTrueTimeStore',
    (primarySmtpAddress: string) => ({
        primarySmtpAddress,
    })
);
